<template>
  <div class="sms-jump-ad">
    <div class="pact">
      <p class="pact-title">科目三路考仪租赁须知</p>
      <p class="sub-title">一、设备租赁清单</p>
      <p class="pact-content">设备名称：科目三路考仪</p>
      <p class="pact-content">设备押金：899元（人民币）/台。</p>
      <p class="sub-title">二、押金退还政策</p>
      <p
        class="pact-content"
      >1. 乙方租用甲方路考仪并激活使用后，每台路考仪累计使用满300个付费学时的，甲方将退还该台路考仪下已缴纳的全部押金;如该设备是免押设备则无需退还押金。若路考仪连续两个月未产生付费学时订单的，甲方有权停用该台路考仪。</p>
      <p
        class="pact-content"
      >2. 未满上述累计付费学时的，乙方应当将路考仪寄送至甲方指定地址，甲方在收到路考仪后，确认外观及功能均完好的情况下，向乙方退还该路考仪已支付的押金；如甲方检测认为路考仪损坏的，乙方应按照本协议第五条予以赔偿，乙方同意其应付的赔偿费用将优先从应退押金中扣除，押金不足以扣除的部分由乙方另行支付。</p>
      <p class="sub-title">三、支付流程条款</p>
      <p
        class="pact-content"
      >1. 甲方将学员付费课时所产生的奖励支付至付费学时订单产生时所登录的超级教练APP账号内，乙方可依照平台规则自行提现，并自行承担对所得奖励金申报和缴纳个税的义务。</p>
      <p class="pact-content">2. 乙方如需向甲方额外支付赔偿费用的，乙方需及时打款至甲方指定的银行账户，汇款时需备注汇款人及路考仪的设备编号。</p>
      <p class="pact-content">平台收款账户：车轮互联科技（上海）股份有限公司</p>
      <p class="pact-content">账号： 310066580013000721922</p>
      <p class="pact-content">开户行：交通银行上海浦东分行</p>
      <br />
      <p class="sub-title">四、赔偿条款</p>
      <p class="pact-content">如乙方在使用时造成所租设备损坏，则按以下价格赔偿：</p>
      <p class="pact-content">1) 显示屏幕碎屏赔偿：300元；</p>
      <p class="pact-content">2) 电脑主板损坏赔偿：300元；</p>
      <p class="pact-content">3) 车载电脑整机丢失赔偿：2000元；</p>
      <p class="pact-content">4) 控制主板损坏赔偿：600元；</p>
      <p class="pact-content">5) 通信线破损赔偿：150元；</p>
      <p class="pact-content">6) 陀螺仪损坏赔偿：150元；</p>
      <p class="pact-content">7) GPS天线损坏赔偿：150元；</p>
      <p class="pact-content">8) 空挡传感器损坏赔偿：150元；</p>
      <p class="pact-content">9) 其他损坏赔偿：按市场价赔偿。</p>
      <p class="sub-title">五、注意事项</p>
      <p class="pact-content">1. 乙方需确保其在“超级教练路考仪”设备激活提交的姓名、联系方式真实有效，否则设备不能使用由乙方自行承担后果</p>
      <p class="pact-content">2. 安装完成后，请使用微信/支付宝“扫一扫”设备上的激活码，提交设备激活申请，激活后即可正常使用该设备；</p>
      <p class="pact-content">3. 双方同意设备发货、返修、退还等过程中产生的运费均由寄件方承担；</p>
      <p
        class="pact-content"
      >4. 设备的安装指导、调试等其他事项，可联系当地服务商，期间产生的拆装费由当地服务商收取，与甲方无关。若无服务商的，可直接联系超级教练团队，联系方式可以通过超级教练app查看;</p>
      <p class="pact-content">5. 乙方在租用期间不得转租；</p>
      <p class="pact-content">6. 乙方不能擅自拆改设备，必须妥善正确使用，确保设备完好无损，否则造成的一切损失由乙方承担；</p>
      <p
        class="pact-content"
      >7. 乙方不得自行或允许第三方对设备进行拆卸、改装、替换、增加或减少部件等一切损害甲方权益的行为，否则甲方有权解除本协议，乙方应当支付10万元人民币作为违约金，违约金不足以弥补甲方损失的，还应当补足;</p>
      <p
        class="pact-content"
      >8. 乙方不得自行或允许第三方获取、披露、使用设备内包含的用户信息以及本协议项下的甲方商业信息，并不得私自更换设备中包含的信息，如支付信息、所有者信息、传输信息等。否则甲方有权解除本协议，乙方应当支付10万元人民币作为违约金，违约金不足以弥补甲方损失的，还应当补足;</p>
      <p
        class="pact-content"
      >9. 禁止私自拆卸、更换设备的零部件、附件等物。如有违规，将按被拆物件的新件价格的10倍处以罚款。情节严重的，甲方有权要求乙方退还设备，乙方拒不退还设备或支付赔偿的，甲方有权通过法律途径向乙方追偿，同时甲方将有权不再对乙方提供任何租赁与售卖服务。</p>
    </div>
  </div>
</template>

<script>
const date = new Date();
export default {
  data() {
    return {
      order: {},
      year: date.getFullYear(),
      month: date.getMonth(),
      day: date.getDate(),
      price: 0
    };
  },
  created: function() {},
  methods: {},
  mounted() {}
};
</script>

<style scoped lang="scss">
.pact {
  background: #fff;
  font-size: 0.24rem;
  line-height: 1.6;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 0 0.3rem;
  z-index: 999;
  padding-bottom: 20px;
  .pact-title {
    text-align: center;
    font-size: 0.34rem;
    font-weight: 600;
    line-height: 1rem;
  }
  .sub-title {
    margin-top: 10px;
    font-size: 0.28rem;
    font-weight: 600;
  }
  .pact-content {
    text-indent: 1em;
    span {
      display: inline-block;
      border-bottom: 1px solid #000;
      min-width: 50px;
      text-align: center;
      text-indent: 0;
    }
  }
  .pact-hint {
    text-align: center;
    margin: 20px auto;
  }
  .footer {
    display: -webkit-flex;
    display: flex;
    span:first-child {
      flex: 3;
    }
    span:last-child {
      flex: 2;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/pactList/leasePact.vue